import { Group, Text, Tooltip } from "@mantine/core";
import { IconTimelineEventPlus } from "@tabler/icons-react";
import { Link } from "react-router";
import { MantineNullCell } from "../../../../../mantine/mrt/components/cell/MantineNullCell";
import { THEME_VARS } from "../../../../../utils/constants";
import { ObjectName } from "../../../../../utils/enums";
import { getLinkToComponentEditModal } from "../../../../../utils/getLinkToComponentEditModal";
import { GENERATOR_EDIT_TABS } from "../../../../ObjectModals/GeneratorModal/GeneratorModal.constants";

interface AnzulegenderWertCellProps {
  generatorId?: number;
  formattedValue: string | null;
  count: number;
  projectId: string;
  siteId: number;
}

function AnzulegenderWertCell({
  generatorId,
  formattedValue,
  count,
  projectId,
  siteId
}: AnzulegenderWertCellProps) {
  if (formattedValue == null) {
    return <MantineNullCell />;
  }

  const hasMultipleValues = count > 1;
  const tooltipLabel = `${count} anzulegende Werte vorhanden`;
  const anzulegendeWerteTablePath =
    hasMultipleValues && generatorId != null
      ? `${getLinkToComponentEditModal(
          ObjectName.Generator,
          generatorId,
          projectId,
          siteId
        )}/general?tab=${GENERATOR_EDIT_TABS.TAB_EEG_ANLAGE_DATA}`
      : null;

  return (
    <Group gap="sm" wrap="nowrap">
      <Text span>{formattedValue}</Text>
      {hasMultipleValues && (
        <Tooltip label={tooltipLabel}>
          {anzulegendeWerteTablePath ? (
            <Link aria-label={tooltipLabel} to={anzulegendeWerteTablePath}>
              <IconTimelineEventPlus
                color={THEME_VARS.primary[6]}
                display="inline-flex"
              />
            </Link>
          ) : (
            <IconTimelineEventPlus
              color={THEME_VARS.primary[6]}
              display="inline-flex"
            />
          )}
        </Tooltip>
      )}
    </Group>
  );
}

export { AnzulegenderWertCell };
